export default {
  authUser: (state, getters) => {
    return state.authId
  }
}
